import React, { useState, useEffect } from 'react';
import { SupplierForm } from './SupplierForm';
import { History } from '../../../../../_metronic/helpers/components/History';
import { Toggle } from '../../../../../_metronic/partials/layout/explore/Toggle';

type Props = {
  proveedor_id: number;
};

const View: React.FC<Props> = ({ proveedor_id }) => {
  const [reloadGrid, setReloadGrid] = useState<number>(Math.random() * 40);

  const onRefreshData = () => {
    setReloadGrid(Math.random() * 40);
  };

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="flex-lg-row-fluid transform">
          <SupplierForm
            proveedor_id={proveedor_id}
            onRefreshHistory={onRefreshData}
            // onDisabledHistory={onDisabledHistory}
          />
        </div>
        {/* <div style={historyStyle}>
          {Number(proyectoId) > 0 && showTimerHistory && (
            <>
              <div className="flex-column flex-lg-row-auto w-100 w-xl-400px ms-lg-10">
                <History
                  data={data}
                  onSaveMessage={saveMessage}
                  disabled={false}
                  onShow={() => {
                    setShowHistory(!showHistory);
                    const boolean = !showHistory;
                    localStorage.setItem('isOpenHistory', boolean.toString());
                  }}
                />
              </div>
            </>
          )}
        </div>
        {!showHistory && Number(proyectoId) > 0 && (
          <Toggle
            onShow={() => {
              setShowHistory(!showHistory);
              setShowTimerHistory(true);
              const boolean = !showHistory;
              localStorage.setItem('isOpenHistory', boolean.toString());
            }}
          />
        )} */}
      </div>
    </>
  );
};

export { View };
